export default "__VITE_ASSET__XCvoUD1x__"